/* eslint-disable */
// import core & vendor packages below
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// import components below
import Table from 'components/ReactTable';
import { selectPatientData } from 'reducers/patientReducer';

// import assets below
import './Table.scss';

// main component
const BloodTypeActionTable = ({ setShowModal, data, filter, filteredData }) => {
  // const data = useSelector(selectPatientData);

  const tableColumns = React.useMemo(
    () => [
      { Header: 'Case ID', accessor: 'id' }, // accessor is the "key" in the data
      // { Header: 'Physician Name', accessor: 'physician_name' },
      { Header: 'Patient Name', accessor: 'name' },
      { Header: 'Date', accessor: 'date' },
    ],
    [],
  );

  const displayedData =
    !filter.patient_name && !filter.case_id && !filter.date ? data : filteredData;

  const tableData = React.useMemo(
    () =>
      displayedData?.map((dd) => ({
        id: dd?.id,
        physician_name: dd?.physician_name,
        name: dd?.full_name,
        date: dd?.admission_date,
      })),
    [data, filteredData],
  );

  const handleTableAction = (eventKey, id) => {
    const row = data.find((dd) => dd.id === id);
    const action = {
      profile: () => { },
      view: () => {
        setShowModal((prevState) => {
          return {
            ...prevState,
            viewRecordModal: true,
            profileData: row,
            profileId: row?.id,
          };
        });
      },
      edit: () => { },
      delete: () => { },
    };

    action[eventKey]();
  };

  return (
    <div className='nursing-blood-type-action-table'>
      <Table
        data={tableData}
        columns={tableColumns}
        actions={{ hasView: true }}
        onAction={handleTableAction}
        pagination={['BOTTOM']}
      />
    </div>
  );
};

BloodTypeActionTable.defaultProps = {
  BloodTypeActionTable: () => { },
};

BloodTypeActionTable.propTypes = {
  setShowModal: PropTypes.func,
};

export default BloodTypeActionTable;